// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"61e4d898","83":"7c6947a7","378":"8673ab20","382":"103f92fb","453":"2358bfe6","931":"1ec9b4a0"}[chunkId] + ".chunk.js";
};